/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParameterModification
 */
export interface ParameterModification {
    /**
     * 
     * @type {string}
     * @memberof ParameterModification
     */
    controlId?: string;
    /**
     * 
     * @type {string}
     * @memberof ParameterModification
     */
    parameterId?: string;
    /**
     * 
     * @type {string}
     * @memberof ParameterModification
     */
    newValue?: string;
    /**
     * 
     * @type {string}
     * @memberof ParameterModification
     */
    constraints?: string;
    /**
     * 
     * @type {string}
     * @memberof ParameterModification
     */
    guidelines?: string;
}

/**
 * Check if a given object implements the ParameterModification interface.
 */
export function instanceOfParameterModification(value: object): value is ParameterModification {
    return true;
}

export function ParameterModificationFromJSON(json: any): ParameterModification {
    return ParameterModificationFromJSONTyped(json, false);
}

export function ParameterModificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParameterModification {
    if (json == null) {
        return json;
    }
    return {
        
        'controlId': json['controlId'] == null ? undefined : json['controlId'],
        'parameterId': json['parameterId'] == null ? undefined : json['parameterId'],
        'newValue': json['newValue'] == null ? undefined : json['newValue'],
        'constraints': json['constraints'] == null ? undefined : json['constraints'],
        'guidelines': json['guidelines'] == null ? undefined : json['guidelines'],
    };
}

export function ParameterModificationToJSON(json: any): ParameterModification {
    return ParameterModificationToJSONTyped(json, false);
}

export function ParameterModificationToJSONTyped(value?: ParameterModification | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'controlId': value['controlId'],
        'parameterId': value['parameterId'],
        'newValue': value['newValue'],
        'constraints': value['constraints'],
        'guidelines': value['guidelines'],
    };
}

